import * as React from 'react';
import { ArrowLeftIcon } from '@mentimeter/ragnar-visuals';
import type { Placement } from '@mentimeter/presentation-state';
import type { ClickableT } from '@mentimeter/ragnar-ui/clickable';
import { useTranslations } from 'next-intl';
import { Hotkey } from '../../misc/hotkeys/Hotkey';
import { ToolbarButton } from '../ToolbarItem';

interface PreviousProps extends ClickableT {
  previous: (placement: Placement) => void;
  hasPrevious: boolean;
  disableHotkeys?: boolean;
  hideTooltip?: boolean;
}

export const Previous = ({
  previous,
  hasPrevious,
  disableHotkeys = false,
  hideTooltip = false,
  ...rest
}: PreviousProps) => {
  const translate = useTranslations('presenting.legacy');

  return (
    <>
      <ToolbarButton
        {...rest}
        ariaLabel={translate('toolbar.previous_slide')}
        id="previous-slide"
        data-testid="toolbar-previous"
        icon={ArrowLeftIcon}
        disabled={!hasPrevious}
        hideTooltip={hideTooltip}
        label={translate('toolbar.previous_slide')}
        onClick={() => previous('Navigation button')}
      />
      {!disableHotkeys && hasPrevious && (
        <>
          <Hotkey
            preventDefault
            keyCode="pageup"
            action={() => previous('Hotkey pageup')}
          />
          <Hotkey
            preventDefault
            keyCode="arrowleft"
            action={() => previous('Hotkey arrowleft')}
          />
        </>
      )}
    </>
  );
};
